import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {Scanner3dModel} from '../../../../scanner3d/common/api/entity/scanner3d.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {EntityWithAuditMetadata} from '../../../../../common/entity/entityWithAuditMetadata';

export class Scan3dGroupSummaryModel extends EntityWithAuditMetadata implements SummaryModel {
    permissions: PermissionsModel;
    partner: PartnerSummaryModel;
    scanner3D: Scanner3dModel;
    scanFormat: LovValueSummary;
    scanMethod: LovValueSummary;
    footPosition: LovValueSummary;
    objectType: LovValueSummary;
    referencial: LovValueSummary;
    normalized: boolean;
    normalizationRequiredManualValidation: boolean;
    hasImage = false;
    id: number;
}
